import { AuditOperation } from '../Services/TaskScheduleApiProviderTypes';
import { formatDateUTC } from '../utils/formatDate';
import { stripHtmlAndTruncate } from '../utils/stripHtmlAndTruncate';
import './AgentAuditOperationDetail.css';
import { buildTrace, TraceRow } from './AgentAuditOperationDetailHelpers';
import AvailableTools from './AvailableTools';
import Table from './Tables';

interface AgentAuditOperationDetailProps<T extends AuditOperation> {
  agentAudit: T | null;
  onClose?: () => void;
  showId?: boolean;
}

function AgentAuditOperationDetail({
  agentAudit,
  onClose,
  showId = false,
}: AgentAuditOperationDetailProps<AuditOperation>) {
  const columns = [
    { name: 'Type', selector: (row: TraceRow) => row.type, sortable: false, width: '120px' },
    {
      name: 'Content',
      selector: (row: TraceRow) => stripHtmlAndTruncate(row.description),
      sortable: false,
    },
  ];

  const availableTools = agentAudit?.available_tools || agentAudit?.trace?.available_tools || [];

  return (
    <div className="d-flex flex-column h-100">
      <h2 className="h4-title">Agent audit operations</h2>

      <div style={{ flexGrow: 1, paddingTop: '1rem' }}>
        {showId && (
          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Id</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <p>{agentAudit?.id}</p>
            </div>
          </div>
        )}
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Duration</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <p>{agentAudit?.duration}</p>
          </div>
        </div>
        <div className="input-block d-flex flex-row justify-between">
          <div className="input-description">
            <div className="input-title">Created At</div>
          </div>
          <div className="align-wrapper d-flex align-center">
            <p>{formatDateUTC(agentAudit?.created_at)}</p>
          </div>
        </div>

        <AvailableTools tools={availableTools} />

        <Table
          title=""
          columns={columns}
          data={buildTrace(agentAudit?.trace_messages)}
          expandableRows={true}
          dense={false}
          noTableHead={false}
          pagination={false}
        />
      </div>
    </div>
  );
}

export default AgentAuditOperationDetail;
